<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Red Monk Wellness – Expert Profiles </h1>
                        <p>Meet the minds redefining personalized IV Therapy and performance wellness in India.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>


<!-- Ashim Matthan Profile
        ================================================== -->

<section class="bg-light-color">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="card card-style-07 border-0 bg-transparent">
                    <div class="image ">
                        <a href="#"><img src="/assets/images/Ashim-Matthan-rhinomight.jpg"
                                alt="Ashim Matthan Rhinomight" /></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                <div class="section-title left mb-3">
                    <!-- <span class="sm-title">RhinoMight </span> -->
                    <h2 class="display-16 lh-1 mb-2">Ashim Matthan</h2>
                    <p class="para">Co-Founder of RhinoMight</p>
                    <div class="line"></div>
                </div>

                <div class="">
                    <!-- <h5 class="mb-2">From Homemaker to Wellness Expert-</h5> -->
                    <ul class="list-unstyled list-style01 mb-0">
                        <li>Specialist in Functional & Regenerative Medicine.</li>
                        <li>Pioneer in cognitive enhancement and neuro recovery techniques.</li>
                    </ul>
                    <!-- <p class="mb-2">- Specialist in Functional & Regenerative Medicine.</p> -->

                </div>

                <div class="mt-1-9">
                    <h5 class="mb-2">Vision - </h5>
                    <p class="mb-2">Bridging neuroscience and longevity for optimal brain and
                        body performance</p>

                </div>

                <div class="mb-3 mt-3 pb-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Functional Wellness Strategist | Brain Performance Architect</h5>

                    <p class="mb-4">Ashim Matthan is a pioneer in functional and performance-based wellness,
                        known for integrating neuroscience and biohacking into everyday health optimization. At
                        Red Monk Wellness, Ashim brings his deep understanding of brain-body synergy to design
                        personalized IV therapy experiences that help individuals achieve sharper focus, faster
                        recovery, and sustainable energy.</p>

                    <p class="mb-4">With a background in science and cognitive performance, he specializes in
                        crafting data-driven IV protocols that promote cellular rejuvenation and immune balance.
                        His philosophy—rooted in measurable outcomes—drives the evolution of IV Vitamin Therapy
                        into a new standard of precision-based wellness.</p>

                    <p class="mb-4">“True recovery begins when the mind and body operate in perfect rhythm.” —
                        Ashim Matthan</p>

                </div>

            </div>



            <div class="col-lg-12 mt-4 d-none wow fadeInUp" data-wow-delay="400ms">

                <div class="mb-0 pb-0 border-top border-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Functional Wellness Strategist | Brain Performance Architect</h5>

                    <p class="mb-4">Ashim Matthan is a pioneer in functional and performance-based wellness,
                        known for integrating neuroscience and biohacking into everyday health optimization. At
                        Red Monk Wellness, Ashim brings his deep understanding of brain-body synergy to design
                        personalized IV therapy experiences that help individuals achieve sharper focus, faster
                        recovery, and sustainable energy.</p>

                </div>


                <div class="mb-0 pb-0 border-top border-0 wow fadeInUp" data-wow-delay="200ms">

                    <p class="mb-4">With a background in science and cognitive performance, he specializes in
                        crafting data-driven IV protocols that promote cellular rejuvenation and immune balance.
                        His philosophy—rooted in measurable outcomes—drives the evolution of IV Vitamin Therapy
                        into a new standard of precision-based wellness.</p>

                    <p class="mb-4">“True recovery begins when the mind and body operate in perfect rhythm.” —
                        Ashim Matthan</p>



                </div>


            </div>

        </div>


    </div>
</section>




<!-- Vision
        ================================================== -->
<section class="bg-light-yellow2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 mb-3 wow fadeInUp" data-wow-delay="100ms">
                <div>
                    <div class="section-title-02 position-relative mb-3">

                        <!-- <span class="sm-title">Portfolio </span> -->
                        <h2 class="position-relative z-index-9 mb-0">Their Vision at Red Monk Wellness</h2>

                    </div>
                    <p class="mb-2">Together, Ashim Matthan and Dr. Kanishka Jain bring the RhinoMight
                        philosophy of precision, performance, and science to Red Monk Wellness, creating India’s
                        most advanced IV Therapy destination. Their combined expertise powers Red Monk’s
                        precision-based IV therapy programs, where real-time diagnostics and personalized
                        formulations help clients achieve rapid recovery, deep hydration, and sustained energy.
                    </p>

                    <p class="mb-2">By merging medical innovation with mindful care, they have positioned Red
                        Monk Wellness as a trusted leader in functional IV therapy, catering to professionals,
                        travelers, athletes, and anyone seeking high-performance wellness.</p>

                </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="200ms">
                <div class="text-center image-hover">
                    <img src="/assets/images/vision.jpg" class="rounded" alt="Vision" />
                </div>
            </div>
        </div>

    </div>
</section>